import React from 'react'
import styled from 'styled-components'
import BackButton from 'components/backButton'
import { Container } from 'components/styled'
import { MEDIA } from 'utils'

const RelativeContainer = styled(Container)`
  position: relative;
  ${props => props.marginTop && 'margin-top: 15px;'}
  ${props => props.isSchedulingSteps && 'padding: 0;'}
  margin: auto;
  max-width: ${props => props.maxWidth ? props.maxWidth : '558px'};
`

const BackButtonContainer = styled.div`
  ${props => props.position === 'absolute' && `
    position: absolute;
    top: 0px;
    left: ${props.offset ? '-15vw' : '-30px'};

    @media screen and ${MEDIA.MOBILE} {
      left: 10px;
      top: -10px;
    }
  `}
`

const PageContainer = ({ maxWidth, children, backOffset, backPosition, onBack, isSchedulingSteps }) => {
  const showBackButton = backPosition === 'relative' || backPosition === 'absolute' || backPosition === 'fixed'
  return (
    <RelativeContainer maxWidth={maxWidth} marginTop={showBackButton} isSchedulingSteps={isSchedulingSteps}>
      {showBackButton && (
        <BackButtonContainer position={backPosition} offset={backOffset}>
          <BackButton onClick={onBack} />
        </BackButtonContainer>
      )}
      {children}
    </RelativeContainer>
  )
}

export default PageContainer
